import { Injectable, Injector } from '@angular/core';
import { DaoBaseService } from './dao-base.service';
import { TemplateDataset } from '../modules/uteis/templates/template.service';
import { UnidadeEntrega } from '../models/unidade-entrega.model';
import { TreeNode } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class UnidadeEntregaDaoService extends DaoBaseService<UnidadeEntrega> {

  constructor(protected injector: Injector) {
    super("UnidadeEntrega", injector);
    this.inputSearchConfig.searchFields = ["descricao"];
  }

  public dataset(deeps?: string[]): TemplateDataset[] {
    return this.deepsFilter([], deeps);
  }

  public hierarquia(unidadeEntregaId: string): Promise<TreeNode[]> {
    return new Promise<any>((resolve, reject) => {
      this.server.post('api/' + this.collection + '/hierarquia', {
        unidade_entrega_id: unidadeEntregaId
      }).subscribe(response => {
        resolve(this.loadHierarquiaDados(response.hierarquia, unidadeEntregaId));
      }, error => {
        console.log("Erro ao montar a hierarquia da entrega!", error);
        resolve([]);
      });
    });
  }

  private loadHierarquiaDados(data: any, unidadeEntregaId: string): TreeNode[] {
    const entregaAtual: TreeNode = this.mapHierarquia(data, unidadeEntregaId);
    const children = data?.filhos ? data?.filhos.flatMap((filho: any) => this.loadHierarquiaDados(filho, unidadeEntregaId)) : [];
    /*if (data.pai) {
      const pai: TreeNode = this.mapHierarquia(data.pai, unidadeEntregaId);
      return [{ ...pai, children: [{ ...entregaAtual, children }] }];
    }*/
    return [{ ...entregaAtual, children }];
  }

  private mapHierarquia(data: any, unidadeEntregaId: string): TreeNode {
    return {
      label: data?.descricao,
      key: data?.id,
      data: data,
      expanded: true,
      styleClass: unidadeEntregaId == data?.id ? 'text-dark' : '', //bg-light 
      children: [],
    };
  }

}

